import { Injectable, Inject } from "@angular/core";
import { DataService } from "../data/data.service";
import { Observable, Observer } from "rxjs";
import { map, filter, merge } from "rxjs/operators";
import { HistoryItemPeriod } from "../../interfaces/historyItem";
import { WorkspaceServiceService } from "../workspace-service.service";

export class DailyOpenRequest {
    public reqId: string = "";
    constructor(public symbol: string, private dataService: DataService) {}

    public sendRequest() {
        // this.dataService.tryToGetFromCache(this.symbol, HistoryItemPeriod.Hr24, 1).then(r=>{

        // })
        // .catch(()=>{
        this.dataService.sendHistoryRequest(this.symbol, HistoryItemPeriod.Hr24, 1).then(r => {
            this.reqId = r;
        }).catch(e => { console.error(e); });
        //});
    }   
}

export class DailyOpenResponse {
    public dailyOpenObservable!: Observable<number | undefined>;
    public sendRequestInterval?: number = undefined;
    constructor(public dailyOpenRequest: DailyOpenRequest) {}
}

@Injectable({
    providedIn: "root"
})
export class DailyOpenService {
    private static dailyOpen: { [symbol: string]: number } = {};

    private refreshDataPeriod = 30 * 60 * 1000;
    constructor(private dataService: DataService, private workspaceService: WorkspaceServiceService) {}

    public getDailyOpen(symbol: string): DailyOpenResponse {
        let request = new DailyOpenRequest(symbol, this.dataService);
        let dailyOpenResponse = new DailyOpenResponse(request);
        //@ts-ignore
        dailyOpenResponse.sendRequestInterval = setInterval(() => request.sendRequest(), this.refreshDataPeriod);
        dailyOpenResponse.dailyOpenObservable = this.dataService.dataSubscriber
            .pipe(filter(serviceResponse => serviceResponse.ReqID == request.reqId))
            .pipe(
                map(serviceResponse => {
                    if (serviceResponse.Periods !== undefined) {
                        return (DailyOpenService.dailyOpen[symbol] = serviceResponse.Periods[0].o);
                    }
                })
            )
            .pipe(
                merge(
                    Observable.create((observer: Observer<number>) => {
                        if (!(symbol in DailyOpenService.dailyOpen)) {
                            request.sendRequest();
                            return;
                        }
                        observer.next(DailyOpenService.dailyOpen[symbol]);
                    })
                )
            );

        return dailyOpenResponse;
    }
}
